/**
 * ImageLoading.js
 */

import $ from 'jquery';
import Utilities from './Utilities';
require('imagesloaded');
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';

export default class ImageLoading {

    constructor() {

        // Background Image with class of .bg-thumb
        $('.bg-thumb').imagesLoaded({
                background: true
            })
            .progress(this.onProgress2);

        // Images from an image tag.
        $('.loading').imagesLoaded()
            .progress(this.onProgress);

        document.addEventListener('lazybeforesizes', function (e) {
            const mainEl = $(e.target).closest('.bg-thumb')
            if (!mainEl) return
            const alt = mainEl.attr('title')
            if (alt) e.target.setAttribute('alt', alt)
        })
    }

    // triggered after each item is loaded
    onProgress(imgLoad, image) {
        $(image.img).removeClass('loading');
    }

    onProgress2(imgLoad, image) {
        $(image.element).removeClass('loading');
    }

}